import { createBrowserRouter } from "react-router-dom";
import { requireAuth } from "../../components/RequireAuth";
import AccessTokenPage from "../../pages/AccessTokenPage";
import ChecklistPage from "../../pages/ChecklistPage";
import DashboardPage from "../../pages/DashboardPage";
import DiseasePage from "../../pages/DiseasePage";
import DocumentPage from "../../pages/DocumentPage";
import EquipmentsPage from "../../pages/EquipmentsPage";
import LocationPage from "../../pages/LocationPage";
import LoginPage from "../../pages/LoginPage";
import MessagePage from "../../pages/MessagePage";
import NotAuthorizedPage from "../../pages/NotAuthorizedPage";
import NotFoundPage from "../../pages/NotFoundPage";
import OperationDetailPage from "../../pages/OperationDetailPage";
import OperationSettingPage from "../../pages/OperationSettingPage";
import OperationTaskBuilder from "../../pages/OperationTaskBuilder";
import OverviewPage from "../../pages/OverviewPage";
import ParseObjectPage from "../../pages/ParseObjectPage";
import PlanOperationPage from "../../pages/PlanOperationPage";
import PreferencePage from "../../pages/PreferencePage";
import RoutePage from "../../pages/RoutePage";
import RouteUpgradePage from "../../pages/RouteUpgradePage";
import SiteMonitoringPage from "../../pages/SiteMonitoringPage";
import SiteOverview from "../../pages/SiteOverviewPage";
import TaskTypeManagementPage from "../../pages/TaskTypeManagementPage";
import UsersPage from "../../pages/UserPage";
import VesselDetailPage from "../../pages/VesselDetailPage";
import VesselManagementPage from "../../pages/VesselManagementPage";
import VessselOverview from "../../pages/VesselOverview";
import WeatherPage from "../../pages/WeatherPage";
import { version } from "../api/v1";
import { PATHNAME } from "../varibles/constants";
import { ACTION } from "../varibles/permission";

const publicRoute = { isPublic: true };

export const router = createBrowserRouter([
    { path: PATHNAME.LOCATION, element: requireAuth(<LocationPage />, ACTION.LOCATION.VIEW) },
    { path: PATHNAME.LOGIN, element: <LoginPage />, handle: publicRoute },
    { path: PATHNAME.HOME, element: requireAuth(<DashboardPage />, ACTION.DASHBOARD.VIEW) },
    { path: PATHNAME.DASHBOARD, element: requireAuth(<DashboardPage />, ACTION.DASHBOARD.VIEW) },
    { path: PATHNAME.PARSE_OBJECT, element: <ParseObjectPage />, handle: publicRoute },
    { path: PATHNAME.ACCESS_TOKEN, element: <AccessTokenPage />, handle: publicRoute },
    { path: PATHNAME.PLAN, element: requireAuth(<PlanOperationPage />, ACTION.PLAN_OP.VIEW) },
    { path: `${PATHNAME.VESSEL}/:id`, element: requireAuth(<VesselDetailPage />, ACTION.VESSEL.VIEW) },
    { path: PATHNAME.OVERVIEW, element: requireAuth(<OverviewPage />, ACTION.OVERVIEW.VIEW) },
    { path: `${PATHNAME.OPERATION}/:tenant_id/:id`, element: requireAuth(<OperationDetailPage />, ACTION.OP_DETAIL.VIEW) },
    { path: PATHNAME.ROUTE, element: requireAuth(<RoutePage />, ACTION.ROUTE.VIEW) },
    { path: PATHNAME.ROUTE_UPGRADE, element: requireAuth(<RouteUpgradePage />, ACTION.ROUTE.VIEW) },
    { path: PATHNAME.CHECKLIST, element: requireAuth(<ChecklistPage />, ACTION.CHECKLIST.VIEW) },
    { path: PATHNAME.VESSEL, element: requireAuth(<VesselManagementPage />, ACTION.VESSEL.VIEW) },
    { path: PATHNAME.WEATHER, element: requireAuth(<WeatherPage />, ACTION.WEATHER.VIEW) },
    { path: PATHNAME.USER, element: requireAuth(<UsersPage />, ACTION.USER.VIEW) },
    { path: PATHNAME.SITE_MONITORING, element: requireAuth(<SiteMonitoringPage />) },
    { path: PATHNAME.PREFERENCE, element: requireAuth(<PreferencePage />, ACTION.PREFERENCE.VIEW) },
    { path: PATHNAME.TASK_TYPE, element: requireAuth(<TaskTypeManagementPage />) },
    { path: PATHNAME.OPERATION_SETTING, element: requireAuth(<OperationSettingPage />, ACTION.OP_SETTING.VIEW) },
    // { path: PATHNAME.COMBINED_TREATMENT, element: requireAuth(<CombineTreatmentPage />, ACTION.COMBINE_TREATMENT.VIEW) },
    { path: PATHNAME.OPERATION_TASK_BUILDER, element: requireAuth(<OperationTaskBuilder />, ACTION.OPERATION_TASK_BUILDER.VIEW) },
    { path: PATHNAME.MESSAGE, element: requireAuth(<MessagePage />, ACTION.MESSENGER.VIEW) },
    { path: PATHNAME.DISEASE, element: requireAuth(<DiseasePage />, ACTION.DISEASE.VIEW) },
    { path: PATHNAME.EQUIPMENT, element: requireAuth(<EquipmentsPage />, ACTION.EQUIPMENT.VIEW) },
    { path: PATHNAME.SITE_OVERVIEW, element: requireAuth(<SiteOverview />, ACTION.BIOLOGY_OVERVIEW.VIEW) },
    { path: PATHNAME.VESSEL_OVERVIEW, element: requireAuth(<VessselOverview />, ACTION.VESSEL_OVERVIEW.VIEW) },
    { path: PATHNAME.ACCESS_DENIED, element: <NotAuthorizedPage />, handle: publicRoute },
    { path: version, element: <DocumentPage />, handle: publicRoute },
    { path: '*', element: <NotFoundPage />, handle: publicRoute }
]);

export const isCurrentRoutePublic = () => router.state.matches.some(match => match.route.handle?.isPublic);


export const nextPage = (path: PATHNAME | string, replace = true) => {
    router.navigate(path, { replace: replace }).then();
}

export const prevPage = () => {
    const { navigation } = router.state || {};
    const { state = 'idle' } = navigation || {}
    if (state === 'idle')
        router.navigate(PATHNAME.HOME, { replace: true }).then()
    else
        router.navigate(-1).then();
}

export const openPage = (url: string) => {
    window.open(`${window.location.protocol}//${window.location.host}${url}`, "_blank");
}

export const getParamsFromUrl = (state = router.state) => {
    return state.matches[0].params || {};
}

export const getSearchFromUrl = (state = router.state) => {
    const { search } = state.location;
    return search.replace('?', '').split('&') || '';
}

export const addRouterListener = router.subscribe
